<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <PageTitle></PageTitle>
        <b-card>
          <div class="bd-example">
            <dl class="row">
              <dt class="col-sm-3">{{ $tc('page.generic.state', 1) }}</dt>
              <dd class="col-sm-9">
                <custom-switch
                  id="enabled"
                  v-model="source.enabled"
                  disabled
                  color="success"
                  variant="pill"
                  label
                />
              </dd>
              <dt class="col-sm-3">{{ $t('page.generic.code') }}</dt>
              <dd class="col-sm-9">{{source.code}}</dd>
              <dt class="col-sm-3">{{ $t('page.generic.name') }}</dt>
              <dd class="col-sm-9">{{source.label}}</dd>
              <dt class="col-sm-3">{{ $t('source.timeToLive') }}</dt>
              <dd class="col-sm-9">{{ source.timeToLive }} ore</dd>
              <dt class="col-sm-3">{{ $t('page.generic.description') }}</dt>
              <dd class="col-sm-9">{{ source.description }}</dd>
            </dl>
          </div>
          <div class="row">
            <div class="col-sm-12">
              <button class="btn btn-danger float-right padder" variant="danger" @click="deleteModal = true"
                      type="button">
                {{ $t('actions.delete') }}
              </button>
              <router-link v-if="source.id" class="btn btn-primary float-right" role="button"
                           :to="{name: 'sourceEditRoute', params: {id:source.id}}">
                {{ $t('actions.edit') }}
              </router-link>
              <!-- Modal Component -->
              <b-modal title="Eliminazione Sorgente" class="modal-danger" v-model="deleteModal" @ok="deleteSource"
                       ok-variant="danger">
                {{ $t('page.generic.deleteMessage', {n: source.code}) }}
              </b-modal>
            </div>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import miniToastr from 'mini-toastr' //ES6
import PageTitle from '@/components/PageTitle'
import SourceService from "@/services/SourceService";
import CustomSwitch from "@/components/CustomSwitch";

const sourceService = SourceService.build();

export default {
  name: 'sourceShow',
  props: {
    id: {
      required: true
    }
  },
  components: {
    PageTitle,
    CustomSwitch
  },
  data() {
    return {
      deleteModal: false,
      source: {}
    }
  },
  created() {
    miniToastr.init(); // config can be passed here miniToastr.init(config)
    miniToastr.setIcon('error', 'i', {'class': 'fas fa-exclamation-triangle'});
    this.fetchData()
  },
  methods: {
    async fetchData() {
      this.source = await sourceService.read(this.id)
    },
    async deleteSource() {
      try {
        // TODO Verificare cancellazione solo se non associata ad altre prestazioni
        await sourceService.destroy(this.id);
        this.$router.replace({name: 'sourceRoute'});
        miniToastr.info("Sorgente cancellata con successo!")
      } catch (exception) {
        miniToastr.error(exception.message)
      }
    }
  }
}
</script>
